// eslint-disable-next-line import/no-duplicates
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import ImpressionsHandler from '@nykaa/deals-utils/impressions';
import ClickHandler from '@nykaa/deals-utils/clicks';
import { webActionTypes } from '@nykaa/deals-utils/clicks/constants';
import { IMPRESSION_TYPE } from '@nykaa/deals-utils/impressions/constants';
import CONFIGURATIONS, { buttonTexts } from './constants';
import { PRODUCT_EVENT } from '../../constants';
import { handleRightClickCallback } from '../../helper';
import IoElement from '../IOElement';
import { ButtonGroup, CardWrapper, Highlights, Message, ProductCardWrapper, ProductContent, ProductPrice, ProductUnit, ProductTag, Sticker, ImageContainer, Ratings, } from './css';
const ProductV2Child = (widgetData) => {
    var _a;
    const [isLoading, setIsLoading] = React.useState(false);
    const width = 1000;
    const { params, trackingData: oldTrackingData, isServer, isDesktop, positionInParent, cssStyle, cta, isDevModeEnabled, devModeData, } = widgetData;
    const { id, imageUrl, slug, trackingParams, parentWidgetId, appLinkData, appLinkType, productOptions, title, salePrice, discountedPrice, message, rating, ratingCount, stickerUrl, tagText, brandName, inStock, highlights, variantType, discountPercent, sku, price, mrp, quantity, dynamicTags, } = params;
    if (!id) {
        return null;
    }
    const { handleAddToCart, wishlist } = cta;
    const { wishlistData, handleWishList } = wishlist;
    const isProductInWishlist = React.useMemo(() => wishlistData && wishlistData.length > 0 && wishlistData.indexOf(id.toString()) !== -1, [wishlistData, id]);
    const definedWidth = (width * CONFIGURATIONS.CARD_WIDTH_RATIO);
    const definedHeight = (width * CONFIGURATIONS.CARD_HEIGHT_RATIO);
    let cardWidth = (width > CONFIGURATIONS.MAX_DEVICE_WIDTH
        ? CONFIGURATIONS.MIN_CARD_WIDTH
        : definedWidth);
    cardWidth = (isDesktop ? CONFIGURATIONS.MAX_CARD_WIDTH : cardWidth);
    let cardHeight = (width > CONFIGURATIONS.MAX_DEVICE_WIDTH
        ? CONFIGURATIONS.MIN_CARD_HEIGHT
        : definedHeight);
    cardHeight = (isDesktop ? CONFIGURATIONS.MAX_CARD_HEIGHT : cardHeight);
    const { ctaStyle, messageStyle, priceUnitStyle, brandProductStyle, shadeSizeStyle, highlightStyle, productTagStyle, stickerStyle, ratingStyle, spacingStyle, } = cssStyle;
    let formattedSlug = slug || '';
    if (formattedSlug && formattedSlug[0] !== '/') {
        formattedSlug = `/${formattedSlug}`;
    }
    const isHighlight = !!(highlights && highlights.length > 0);
    const dnImpressionData = {
        position1: oldTrackingData.position1,
        dn_page_type: oldTrackingData.namespace0,
        dn_page_section: oldTrackingData.namespace1,
        dn_tile_id: oldTrackingData.namespace2,
        dn_inventory_position: oldTrackingData.position1,
        dn_tile_position: oldTrackingData.position2,
        dn_transaction_id: oldTrackingData.transaction_id || `wid_${parentWidgetId}`,
        dn_tracking_metadata: params.trackingData.dn_tracking_metadata,
        dn_request_page_data: oldTrackingData.pageData1,
        dn_inventory_page_data: oldTrackingData.pageData2,
        dn_wtype: oldTrackingData.wtype,
        dn_wtype_version: oldTrackingData.wtype_version,
    };
    const productTrackingData = {
        product_sku: sku,
        product_price: price,
        product_mrp: mrp,
        product_dp: price,
        product_inventory: quantity,
        product_name: title,
        product_tags: dynamicTags || [],
        product_id: id,
        product_position: positionInParent - 1,
        product_brand: brandName,
        page_url: typeof window !== 'undefined' ? window.location.href : '',
    };
    const preparedProductTrackingData = Object.assign(Object.assign({}, productTrackingData), dnImpressionData);
    const clickedTrackingData = Object.assign(Object.assign({}, preparedProductTrackingData), { event_name: PRODUCT_EVENT.CLICK, event_type: 'click' });
    const handleIntersect = () => {
        ImpressionsHandler.syncCallback([Object.assign(Object.assign({}, preparedProductTrackingData), { hit_recorded_at: new Date().getTime() / 1000, event: 'product:impressions', event_name: PRODUCT_EVENT.IMPRESSIONS, id })], IMPRESSION_TYPE.PRODUCT);
    };
    const clickHandler = (event) => {
        event.preventDefault();
        event.stopPropagation();
        ImpressionsHandler.handleClick(clickedTrackingData).finally(() => {
            /**
             * ? Why finally?
             * even in case of an error in handling impression...
             * we would want the click to function as expected
             */
            ClickHandler.handleClick({
                appLinkData,
                appLinkType,
                trackingParams,
                webActionType: webActionTypes.URL_REDIRECTION,
                webActionUrl: formattedSlug,
                isDesktop,
            });
        });
    };
    const getCTAtext = () => {
        if (!inStock) {
            return buttonTexts.NOTIFY_ME;
        }
        if (isLoading) {
            return buttonTexts.ADDING;
        }
        const varintTypeButtonText = `${CONFIGURATIONS.SELECT_TEXT} ${variantType}`;
        return variantType ? varintTypeButtonText : buttonTexts.ADD_TO_CART;
    };
    const messageDisplay = inStock
        ? message
        : CONFIGURATIONS.OUT_OF_STOCK;
    const ratingsDisplay = ` ${(_a = Number(rating || 0)) === null || _a === void 0 ? void 0 : _a.toFixed(1)}`;
    const ratingCountDisplay = ` (${ratingCount})`;
    const transformPrice = (processedPrice) => (processedPrice.toLocaleString());
    const transformedSalePrice = transformPrice(salePrice);
    const transformedDiscountPrice = transformPrice(discountedPrice);
    const handleWishListClick = () => {
        handleWishList(params, isProductInWishlist, Object.assign({}, preparedProductTrackingData));
    };
    const handleAddToCartClick = () => !isLoading && handleAddToCart(params, setIsLoading, Object.assign({}, preparedProductTrackingData));
    const devModeHandler = (!!isDevModeEnabled && {
        onContextMenu: () => handleRightClickCallback(devModeData),
    });
    return (React.createElement(CardWrapper, { interItem: spacingStyle.interItem, padding: spacingStyle.padding, key: id + positionInParent, isDesktop: isDesktop, width: cardWidth },
        React.createElement(IoElement, { isServer: isServer, onIntersect: handleIntersect, className: "width-limiter", childClassName: "width-limiter", isV2Present: false },
            React.createElement(ProductCardWrapper, { isDesktop: isDesktop, width: cardHeight, tagText: tagText },
                React.createElement("div", Object.assign({ onClick: clickHandler, className: "product-image" }, devModeHandler),
                    React.createElement("div", { className: "product-head" }, tagText && (React.createElement(ProductTag, { background: productTagStyle.bkg, text: productTagStyle.text, margin: productTagStyle.margin, padding: productTagStyle.padding, cornerRadius: productTagStyle.cornerRadius }, tagText))),
                    React.createElement(ImageContainer, { width: cardHeight, isHighlight: isHighlight, imageUrl: imageUrl },
                        React.createElement("div", { className: "container" },
                            React.createElement("div", { className: "ratings-container" }, !!rating && (React.createElement(Ratings, { actualRatingText: ratingStyle.actualRatingtext, background: ratingStyle.bkg, cornerRadius: ratingStyle.cornerRadius, margin: ratingStyle.margin, maxRatingtext: ratingStyle.maxRatingtext, padding: ratingStyle.padding },
                                React.createElement("span", { className: "actual-rating" },
                                    "\u2605",
                                    ratingsDisplay),
                                React.createElement("span", { className: "rating-count" }, `/${CONFIGURATIONS.MAX_RATING_COUNT} ${ratingCountDisplay}`)))),
                            React.createElement("div", { className: "sticker-container" },
                                React.createElement(Sticker, { url: stickerUrl, margin: stickerStyle.margin }))),
                        isHighlight && (React.createElement(Highlights, { background: productTagStyle.bkg, text: highlightStyle.text, margin: highlightStyle.margin, padding: highlightStyle.padding }, highlights.map((highlight) => (React.createElement("li", { key: highlight }, highlight))))))),
                React.createElement(ProductContent, { brandStyle: brandProductStyle.brandText, productStyle: brandProductStyle.productText, padding: brandProductStyle.padding },
                    React.createElement("div", Object.assign({ onClick: clickHandler }, devModeHandler),
                        React.createElement("div", { className: "header" },
                            React.createElement("div", { className: "product-name" }, title)),
                        React.createElement(ProductUnit, { margin: shadeSizeStyle.margin, padding: shadeSizeStyle.padding, text: shadeSizeStyle.text }, productOptions),
                        React.createElement(ProductPrice, { discountText: priceUnitStyle.discountText, margin: priceUnitStyle.margin, padding: priceUnitStyle.padding, mrpPriceText: priceUnitStyle.mrpPriceText, salePriceText: priceUnitStyle.salePriceText },
                            React.createElement("div", { className: "sale-price" },
                                "\u20B9",
                                transformedDiscountPrice),
                            (discountPercent !== 0) && (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "mrp-price" },
                                    "\u20B9",
                                    transformedSalePrice),
                                React.createElement("div", { className: "discounted-price" }, `${discountPercent}%`),
                                ' ')))),
                    React.createElement(Message, { margin: messageStyle.margin, padding: messageStyle.padding, text: inStock ? messageStyle.positiveText : messageStyle.negativeText }, messageDisplay)),
                !isDesktop && (React.createElement(ButtonGroup, { margin: ctaStyle.margin, padding: ctaStyle.padding, text: ctaStyle.text, background: ctaStyle.bkg, border: ctaStyle.border, cornerRadius: ctaStyle.cornerRadius, isProductInWishList: isProductInWishlist, isDesktop: isDesktop },
                    React.createElement("button", { type: "button", "aria-label": "wishlist", className: "wishlist", onClick: handleWishListClick }),
                    React.createElement("button", { type: "button", className: "add_to_cart", onClick: handleAddToCartClick }, getCTAtext())))))));
};
export default ProductV2Child;
